module.exports = __webpack_public_path__ + "img/current_jackpot_bg.12411e9b.png";